import { Typography } from '@mui/material'
import classNames from 'classnames'

const TransportItem = ({ title, handler, Icon, active, disabled }) => {
  return (
    <div className={classNames('transport_item', { active, disabled })} onClick={handler}>
      {Icon && <Icon className="transport_item_icon" />}
      <Typography className="transport_item_title">{title}</Typography>
    </div>
  )
}

export default TransportItem
